var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{attrs:{"id":"app"}},[_c('v-snackbar',{attrs:{"value":_vm.snackbarText}},[_vm._v(" "+_vm._s(_vm.snackbarText)+" ")]),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }